import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { Control, Path } from "react-hook-form";
import { IconButton } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { InputField } from "@src/shared/ui/InputField";
import { CreatingSearchHHForm } from "../constans";

import styles from "./RequirementsDndLists.module.scss";

type TListName = "mandatory" | "priority" | "optional";

interface Props {
  control: Control<CreatingSearchHHForm>;
  name: TListName;
  index: number;
  uid: string;
  dndId: string;
  placeholder: string;
  isDisabled?: boolean;
  onRemove: () => void;
}

export const SortableEditableListItem = ({
  control,
  name,
  index,
  dndId,
  placeholder,
  isDisabled,
  onRemove,
}: Props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: dndId,
    disabled: isDisabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`${styles.item} ${isDragging ? styles.itemDragging : ""}`}
    >
      <button
        type="button"
        className={styles.dragHandle}
        disabled={isDisabled}
        {...attributes}
        {...listeners}
      >
        <DragIndicatorIcon sx={{ width: 20, height: 20 }} />
      </button>

      <InputField
        control={control}
        name={`${name}.${index}.value` as Path<CreatingSearchHHForm>}
        className={styles.inputField}
        classNameForWrapper={styles.inputFieldWrapper}
        placeholder={placeholder}
        disabled={isDisabled}
      />

      <IconButton
        type="button"
        onClick={onRemove}
        disabled={isDisabled}
        className={styles.deleteButton}
      >
        <DeleteOutlineIcon sx={{ width: 20, height: 20 }} />
      </IconButton>
    </div>
  );
};